import { useApi } from "../../../swr/useApi";
import { adminWarrantyProductsService } from "../../api_client";
import type { WarrantyProductDto } from "../../../api";

export function useAdminWarrantyProducts() {
  return useApi<WarrantyProductDto[]>(
    "admin-warranty-products",
    () => adminWarrantyProductsService.adminListWarrantyProducts(),
  );
}
